import { Box } from "@mui/material";

import { ProductCC } from "api/public/pcm/pcm.types";
import { withForm } from "components/Forms/AppForm";

import { pcmFormDefaultValues } from "./pcmFormDefaultValues";

const ProductSelectSection = withForm({
  defaultValues: pcmFormDefaultValues,
  props: {
    ccProducts: [] as ProductCC[],
  },
  render: function Render({ form, ccProducts }) {
    const formattedProducts = ccProducts
      .map((ccp) => ({
        label: ccp.name,
        value: ccp.ccid,
      }))
      .sort((a, b) => a.label.localeCompare(b.label));

    return (
      <Box sx={{ mb: 4 }}>
        <form.AppField
          name="ccProduct"
          listeners={{
            onChange: ({ value }) => {
              const product = ccProducts.find(
                (ccp) => ccp.ccid === value.value,
              )!;
              // Reset maintenance field when product changes
              // Data fetching is handled reactively by usePcmCascadingData
              form.resetField("ccMaintenance");
              form.setFieldValue("vendor", product?.vendor_name ?? "");
            },
          }}
        >
          {(field) => (
            <field.AutocompleteSelect
              options={formattedProducts}
              label="Product"
              required
            />
          )}
        </form.AppField>
      </Box>
    );
  },
});

export default ProductSelectSection;
